/* @flow */
export default {
  textValue: `(key) => (this.values[key])`,
  concatValues: `(keys, separator = " ") => keys.reduce( (accumulator, key) => ( accumulator + this.values[key] + separator ) , "" )`,
  textAndValue: `(text, key) => {return text + " " + (this.values[key] || '')}`,
  dateString: `(key, locale) => {  
    const date = new Date(this.values[key]); 
    return new Intl.DateTimeFormat(locale).format(date).toString();
  }`
};
